// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"5e0f5af0","232":"aa893f5b","237":"29d35b09","357":"1f5c5b6f","526":"787f9d71","872":"e3b79d84"}[chunkId] + ".chunk.js";
};